import { Component } from '@angular/core';

@Component({
  selector: 'app-informacion-contacto',
  templateUrl: './informacion-contacto.component.html',
  styleUrls: ['./informacion-contacto.component.scss'],
  standalone: false,
})
export class InformacionContactoComponent {}
